var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.equipment=='mobile')?_c('div',{staticClass:"mobile"},[_c('Mindex')],1):_c('div',{staticClass:"computer"},[_c('Cindex')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }